<template>
  <div :class="device === 'mobile' ? 'set-password mobile' : 'set-password'">
    <h1 class="title">设置密码</h1>
    <h5 class="description">为了方便后续登录，请设置密码</h5>
    <a-form class="form" :form="form">
      <!-- 密码 -->
      <a-form-item>
        <a-input
          v-decorator="['password1',{ rules: [{ required: true, message: '请输入登录密码!' }] },]"
          type="password"
          placeholder="密码"
        >
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>

      <!-- 确认密码 -->
      <a-form-item>
        <a-input
          v-decorator="['password2',{ rules: [{ required: true, message: '请输入登录密码!' }] },]"
          type="password"
          placeholder="确认密码"
        >
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>

      <!-- 重置密码按钮 -->
      <a-form-item>
        <a-button type="primary" :loading="loading" block @click="handleSubmit">{{buttonText}}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
export default {
  props: [ 'device' ],
  data() {
    return {
      form: this.$form.createForm(this), // from表单实例
      buttonText: "确认",
      loading: false
    };
  },

  methods: {
    // 重置按钮状态
    setBtnStatus(text, state) {
      this.buttonText = text;
      this.loading = state;
    },

    // 设置密码按钮
    handleSubmit() {
      let that = this;
      try {
        that.setBtnStatus("正在提交", true);
        setTimeout(() => {
          that.$message.success("设置成功");
          that.setBtnStatus("确认", false);
        }, 2000);
      } catch (error) {
        that.setBtnStatus("确认", false);
        console.log(error);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.set-password {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f0f2f5 no-repeat;
  background-position: 0 132px;
  background-image: url('../../assets/images/account/big_shape2.png');

  &.mobile {
    .description, .title, .form { width: 95%;}
  }

  .title {
    font-weight: bold;
    font-size: 22px;
    background-color: #fff;
    width: 400px;
    text-align: center;
    padding-top: 30px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
  .description {
    width: 400px;
    text-align: center;
    font-size: 14px;
    padding-bottom: 15px;
    padding-top: 5px;
    color: #999;
    background: #fff;
  }

  .form {
    width: 400px;
    background-color: #fff;
    padding: 15px 30px 40px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;

    /deep/.ant-input,
    .ant-btn {
      height: 38px;
    }
  }
}
</style>
